import React, {useMemo} from 'react';
import {Card, CardActions, CardContent, Typography} from "@mui/material";
import {CardData, CardTitle} from "@atttomyx/react-components";
import {arrays, datetime} from "@atttomyx/shared-utils";
import {filters as constants} from "@atttomyx/shared-constants";

const FormCard = (props) => {
    const { questionnaire, prerequisite, filters, children } = props;

    const description = useMemo(() => {
        return arrays.splitOnNewline(questionnaire.description);
    }, [questionnaire.description]);

    return <Card className="form-card" raised={true}>
        <CardContent>
            <CardTitle>
                <Typography variant="body1">
                    {questionnaire.title}
                </Typography>
                {description.length > 0 ?
                    <Typography variant="caption">
                        {description[0]}{description.length > 1 ? "..." : null}
                    </Typography> : null}
            </CardTitle>
            <CardData
                filters={filters}
                data={questionnaire}
                keyToMetadata={{
                    prerequisite: {
                        title: "Prerequisite",
                        getter: (data) => prerequisite,
                        type: constants.TYPE_BOOLEAN,
                        formatter: (value) => value ? constants.TRUE : constants.FALSE,
                    },
                    order: {
                        title: "Index",
                    },
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default FormCard;
